import { createSelector } from "reselect";
import get from "lodash/get";
import find from "lodash/find";
import { constructPortInNumberValidation } from "utils/helpers";
import {
  inCompleteOrderSelector,
  totaltelcoListSelector,
  localeSelector
} from "ducks/selectors";

export const validatePortInNumberDomain = state =>
  get(state, "api.validatePortInNumber", {});

export const validatePortInNumberSelector = createSelector(
  localeSelector,
  validatePortInNumberDomain,
  constructPortInNumberValidation
);

export const makeSelectPortInNumberValidation = () =>
  validatePortInNumberSelector;

export const makeSelectPortInValues = () =>
  createSelector(
    inCompleteOrderSelector,
    totaltelcoListSelector,
    (order = {}, telolist) => {
      const { is_port_in_request, port_number, telco } = order;
      const telcoName = find(telolist, { value: telco });
      return {
        ...(is_port_in_request && { port_number, telco: telcoName })
      };
    }
  );
